import React from "react";
import styled from "styled-components";
import { componentTypeInfo } from "./utils";

interface Props {
  type?: string;
  className?: string;
}

const Badge = styled.span<{ $color: string }>`
  min-height: 25px;
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 14px;
  color: var(--gray400);
  color: ${(props) => props.$color};
  border: 1px solid ${(props) => props.$color};
  background-color: var(--dark300);
  margin-right: 5px;
`;

const ComponentTypeBadge = (props: Props) => {
  const { type, className } = props;

  const { title, color } = componentTypeInfo(type);

  return (
    <Badge $color={color} className={className}>
      {title}
    </Badge>
  );
};

export default ComponentTypeBadge;
